// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealsItems_meal__2c67n","description":"MealsItems_description__1RTEe","price":"MealsItems_price__8qsio"};